import {
    ITravelServiceMock
} from './index'

export const mockTravelService = (): ITravelServiceMock => ({
    getAll: jest.fn(),
    getById: jest.fn(),
    getLimits: jest.fn(),

    // criteria
    getAllAccommodation: jest.fn(),
    getAccommodationById: jest.fn(),
    getAllLocation: jest.fn(),
    getLocationById: jest.fn(),
    getAllTaste: jest.fn(),
    getTasteById: jest.fn(),
    getAllTravelType: jest.fn(),
    getTravelTypeById: jest.fn(),
    getAllSeason: jest.fn(),
    getSeasonById: jest.fn()
})
